import React, { useContext } from "react";
import { AuthContext, AuthContexType } from "../context/AuthContext";
import { Navigate, Outlet } from "react-router-dom";

const Protected = () => {
  const { token } = useContext(AuthContext) as AuthContexType;
  return token ? <Outlet /> : <Navigate to="/login" replace />;
};

export default Protected;
